<qwiko-splash-loader></qwiko-splash-loader>
<router-outlet></router-outlet>

<!-- Install modal -->
<qwiko-modal
  [id]="'install_modal'"
  [isCentered]="true"
  [isDismissible]="false"
  *transloco="let t; prefix: 'install_modal'"
>
  <div
    class="max-w-sm z-50 pt-2 pb-2 md:px-2 bg-white dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
  >
    <div class="flex justify-end mb-2 w-full">
      <button
        type="button"
        class="btn btn-sm btn-ghost rounded-box"
        (click)="modalService.close('install_modal')"
      >
        <span class="flex items-center gap-1">
          <i class="fa-light text-neutral-600 text-xl fa-xmark"></i>
        </span>
      </button>
    </div>
    <div class="w-full px-4 py-2 mx-auto">
      <img
        class="rounded-box size-20 mx-auto mb-4"
        src="/assets/logo/qwiko-icon-dark.svg"
        alt=""
      />
      <h2 class="text-2xl font-semibold text-center w-full mb-2">
        {{ t("title") }}
      </h2>
      <h2 class="text-lg font-light text-center w-full mb-2">
        {{ t("subtitle") }}
      </h2>
    </div>
    <div class="mt-5 card py-4 px-6 md:px-5 w-full">
      <button
        type="button"
        class="btn btn-md w-10/12 mx-auto btn-primary rounded-box"
        (click)="install()"
        [disabled]="loading()"
      >
        @if (loading()) {
          <span class="loading loading-spinner"></span>
        } @else {
          <span> {{ t("install") }} </span>
        }
      </button>
    </div>
  </div>

  <!-- <div
    class="w-full md:w-8/12 mx-auto max-h-[80vh] my-5 pb-10 px-6 md:px-5 overflow-y-auto"
  >
    <button
      type="button"
      class="btn btn-sm btn-ghost rounded-box w-full"
      (click)="modalService.close('install_modal')"
    >
      <span class="flex items-center gap-1">
        <i class="fa-light text-xl fa-xmark"></i>
        <span class="text-base mt-1">{{ t("click_to_close") }}</span>
      </span>
    </button>
  </div> -->

  <!-- <div
    class="fixed bottom-0 right-0 left-0 mt-5 md:mt-10 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
  >
    <button
      type="button"
      class="btn btn-md w-full md:w-8/12 mx-auto btn-primary rounded-box"
      (click)="install()"
    >
      @if (loading()) {
        <span class="loading loading-spinner"></span>
      } @else {
        <span> {{ t("install") }} </span>
      }
    </button>
  </div> -->
</qwiko-modal>

<!-- Update Modal -->
<qwiko-modal
  [id]="'update_modal'"
  [isCentered]="true"
  [isDismissible]="false"
  *transloco="let t; prefix: 'update_modal'"
>
  <div
    class="max-w-md z-50 pt-2 pb-2 md:px-2 bg-white dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
  >
    <div class="flex justify-end mb-2 w-full">
      <button
        type="button"
        class="btn btn-sm btn-ghost rounded-box"
        (click)="modalService.close('update_modal')"
      >
        <span class="flex items-center gap-1">
          <i class="fa-light text-neutral-600 text-xl fa-xmark"></i>
        </span>
      </button>
    </div>
    <div class="w-full px-4 py-2 mx-auto">
      <img
        class="rounded-box size-20 mx-auto mb-4"
        src="/assets/logo/qwiko-icon-dark.svg"
        alt=""
      />
      <h2 class="text-2xl font-semibold text-center w-full mb-2">
        {{ t("title") }}
      </h2>
      <h2 class="text-lg font-light text-center w-full mb-2">
        {{ t("subtitle") }}
      </h2>
    </div>
    <div class="mt-5 md:mt-10 card py-4 px-6 md:px-5 w-full">
      <button
        type="button"
        class="btn btn-md w-10/12 mx-auto btn-primary rounded-box"
        (click)="reload()"
      >
        @if (loading()) {
          <span class="loading loading-spinner"></span>
        } @else {
          <span> {{ t("install_update") }} </span>
        }
      </button>
    </div>
  </div>

  <!-- <div
    class="w-full md:w-8/12 mx-auto max-h-[80vh] my-5 pb-10 px-6 md:px-5 overflow-y-auto"
  >
    <button
      type="button"
      class="btn btn-sm btn-ghost rounded-box w-full"
      (click)="modalService.close('install_modal')"
    >
      <span class="flex items-center gap-1">
        <i class="fa-light text-xl fa-xmark"></i>
        <span class="text-base mt-1">{{ t("click_to_close") }}</span>
      </span>
    </button>
  </div> -->

  <!-- <div
    class="fixed bottom-0 right-0 left-0 mt-5 md:mt-10 card py-4 px-6 md:px-5 rounded-b-none rounded-t-3xl w-full z-50 gap-y-2 bg-neutral-100 dark:bg-base-300 border-t border-t-neutral-200 dark:border-t-neutral-800 shadow dark:shadow-neutral-800"
  >
    <button
      type="button"
      class="btn btn-md w-full md:w-8/12 mx-auto btn-primary rounded-box"
      (click)="install()"
    >
      @if (loading()) {
        <span class="loading loading-spinner"></span>
      } @else {
        <span> {{ t("install") }} </span>
      }
    </button>
  </div> -->
</qwiko-modal>
